/**
 * React entry point
 * Renders the App component into the DOM
 */

import React from "react";
import ReactDOM from "react-dom/client";
import "./tokens.css";
import App from "./App";
import { initNewRelic } from "./lib/newrelic";
import { initGtm } from "./lib/gtm";

initNewRelic();
initGtm();

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
